import { fetchAndActivate, getRemoteConfig, getString } from 'firebase/remote-config';
import { create } from 'zustand';
import { secondaryApp } from 'config/firebase';

interface BannerConfigState {
  config: Record<string, unknown> | null;
  isLoaded: boolean;
  loadConfig: () => Promise<void>;
}

export const useDashboardBannerStore = create<BannerConfigState>((set) => ({
  config: null,
  isLoaded: false,
  loadConfig: async () => {
    try {
      const remoteConfig = getRemoteConfig(secondaryApp);
      await fetchAndActivate(remoteConfig);
      const entityProfile = getString(remoteConfig, 'dashboard_banner_slider');
      const parsed = JSON.parse(entityProfile);
      set({ config: parsed, isLoaded: true });
    } catch (error) {
      console.warn('Error loading dashboard_banner_slider from Remote Config:', error);
      set({ config: null, isLoaded: true });
    }
  },
}));
